//function getFocusableElements(t){return Array.from(t.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))}document.querySelectorAll('[id^="Details-"] summary').forEach((t=>{t.setAttribute("role","button"),t.setAttribute("aria-expanded",t.parentNode.hasAttribute("open")),t.nextElementSibling.getAttribute("id")&&t.setAttribute("aria-controls",t.nextElementSibling.id),t.addEventListener("click",(t=>{t.currentTarget.setAttribute("aria-expanded",!t.currentTarget.closest("details").hasAttribute("open"))})),t.closest("header-drawer")||t.parentElement.addEventListener("keyup",onKeyUpEscape)}));const trapFocusHandlers={};function trapFocus(t,e=t){var i=getFocusableElements(t),s=i[0],o=i[i.length-1];removeTrapFocus(),trapFocusHandlers.focusin=e=>{e.target!==t&&e.target!==o&&e.target!==s||document.addEventListener("keydown",trapFocusHandlers.keydown)},trapFocusHandlers.focusout=function(){document.removeEventListener("keydown",trapFocusHandlers.keydown)},trapFocusHandlers.keydown=function(e){"TAB"===e.code.toUpperCase()&&(e.target!==o||e.shiftKey||(e.preventDefault(),s.focus()),e.target!==t&&e.target!==s||!e.shiftKey||(e.preventDefault(),o.focus()))},document.addEventListener("focusout",trapFocusHandlers.focusout),document.addEventListener("focusin",trapFocusHandlers.focusin),e.focus()}try{document.querySelector(":focus-visible")}catch(t){focusVisiblePolyfill()}function focusVisiblePolyfill(){const t=["ARROWUP","ARROWDOWN","ARROWLEFT","ARROWRIGHT","TAB","ENTER","SPACE","ESCAPE","HOME","END","PAGEUP","PAGEDOWN"];let e=null,i=null;window.addEventListener("keydown",(e=>{t.includes(e.code.toUpperCase())&&(i=!1)})),window.addEventListener("mousedown",(t=>{i=!0})),window.addEventListener("focus",(()=>{e&&e.classList.remove("focused"),i||(e=document.activeElement,e.classList.add("focused"))}),!0)}function pauseAllMedia(){document.querySelectorAll(".js-youtube").forEach((t=>{t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}',"*")})),document.querySelectorAll(".js-vimeo").forEach((t=>{t.contentWindow.postMessage('{"method":"pause"}',"*")})),document.querySelectorAll("video").forEach((t=>t.pause())),document.querySelectorAll("product-model").forEach((t=>{t.modelViewerUI&&t.modelViewerUI.pause()}))}function removeTrapFocus(t=null){document.removeEventListener("focusin",trapFocusHandlers.focusin),document.removeEventListener("focusout",trapFocusHandlers.focusout),document.removeEventListener("keydown",trapFocusHandlers.keydown),t&&t.focus()}function onKeyUpEscape(t){if("ESCAPE"!==t.code.toUpperCase())return;const e=t.target.closest("details[open]");if(!e)return;const i=e.querySelector("summary");e.removeAttribute("open"),i.setAttribute("aria-expanded",!1),i.focus()}class QuantityInput extends HTMLElement{constructor(){super(),this.input=this.querySelector("input"),this.changeEvent=new Event("change",{bubbles:!0}),this.querySelectorAll("button").forEach((t=>t.addEventListener("click",this.onButtonClick.bind(this))))}onButtonClick(t){t.preventDefault();const e=this.input.value;"plus"===t.target.name?this.input.stepUp():this.input.stepDown(),e!==this.input.value&&this.input.dispatchEvent(this.changeEvent)}}function debounce(t,e){let i;return(...s)=>{clearTimeout(i),i=setTimeout((()=>t.apply(this,s)),e)}}function fetchConfig(t="json"){return{method:"POST",headers:{"Content-Type":"application/json",Accept:`application/${t}`}}}customElements.define("quantity-input",QuantityInput),void 0===window.Shopify&&(window.Shopify={}),Shopify.bind=function(t,e){return function(){return t.apply(e,arguments)}},Shopify.setSelectorByValue=function(t,e){for(var i=0,s=t.options.length;i<s;i++){var o=t.options[i];if(e==o.value||e==o.innerHTML)return t.selectedIndex=i,i}},Shopify.addListener=function(t,e,i){t.addEventListener?t.addEventListener(e,i,!1):t.attachEvent("on"+e,i)},Shopify.postLink=function(t,e){var i=(e=e||{}).method||"post",s=e.parameters||{},o=document.createElement("form");for(var n in o.setAttribute("method",i),o.setAttribute("action",t),s){var a=document.createElement("input");a.setAttribute("type","hidden"),a.setAttribute("name",n),a.setAttribute("value",s[n]),o.appendChild(a)}document.body.appendChild(o),o.submit(),document.body.removeChild(o)},Shopify.CountryProvinceSelector=function(t,e,i){this.countryEl=document.getElementById(t),this.provinceEl=document.getElementById(e),this.provinceContainer=document.getElementById(i.hideElement||e),Shopify.addListener(this.countryEl,"change",Shopify.bind(this.countryHandler,this)),this.initCountry(),this.initProvince()},Shopify.CountryProvinceSelector.prototype={initCountry:function(){var t=this.countryEl.getAttribute("data-default");Shopify.setSelectorByValue(this.countryEl,t),this.countryHandler()},initProvince:function(){var t=this.provinceEl.getAttribute("data-default");t&&this.provinceEl.options.length>0&&Shopify.setSelectorByValue(this.provinceEl,t)},countryHandler:function(t){var e=(o=this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),i=JSON.parse(e);if(this.clearOptions(this.provinceEl),i&&0==i.length)this.provinceContainer.style.display="none";else{for(var s=0;s<i.length;s++){var o;(o=document.createElement("option")).value=i[s][0],o.innerHTML=i[s][1],this.provinceEl.appendChild(o)}this.provinceContainer.style.display=""}},clearOptions:function(t){for(;t.firstChild;)t.removeChild(t.firstChild)},setOptions:function(t,e){var i=0;for(e.length;i<e.length;i++){var s=document.createElement("option");s.value=e[i],s.innerHTML=e[i],t.appendChild(s)}}};class MenuDrawer extends HTMLElement{constructor(){super(),this.mainDetailsToggle=this.querySelector("details"),"iPhone"===navigator.platform&&document.documentElement.style.setProperty("--viewport-height",`${window.innerHeight}px`),this.addEventListener("keyup",this.onKeyUp.bind(this)),this.addEventListener("focusout",this.onFocusOut.bind(this)),this.bindEvents()}bindEvents(){this.querySelectorAll("summary").forEach((t=>t.addEventListener("click",this.onSummaryClick.bind(this)))),this.querySelectorAll("button").forEach((t=>t.addEventListener("click",this.onCloseButtonClick.bind(this))))}onKeyUp(t){if("ESCAPE"!==t.code.toUpperCase())return;const e=t.target.closest("details[open]");e&&(e===this.mainDetailsToggle?this.closeMenuDrawer(t,this.mainDetailsToggle.querySelector("summary")):this.closeSubmenu(e))}onSummaryClick(t){const e=t.currentTarget,i=e.parentNode,s=i.closest(".has-submenu"),o=i.hasAttribute("open"),n=window.matchMedia("(prefers-reduced-motion: reduce)");function a(){trapFocus(e.nextElementSibling,i.querySelector("button")),e.nextElementSibling.removeEventListener("transitionend",a)}i===this.mainDetailsToggle?(o&&t.preventDefault(),o?this.closeMenuDrawer(t,e):this.openMenuDrawer(e)):setTimeout((()=>{i.classList.add("menu-opening"),e.setAttribute("aria-expanded",!0),s&&s.classList.add("submenu-open"),!n||n.matches?a():e.nextElementSibling.addEventListener("transitionend",a)}),100)}openMenuDrawer(t){setTimeout((()=>{this.mainDetailsToggle.classList.add("menu-opening")})),t.setAttribute("aria-expanded",!0),trapFocus(this.mainDetailsToggle,t),document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)}closeMenuDrawer(t,e=!1){void 0!==t&&(this.mainDetailsToggle.classList.remove("menu-opening"),this.mainDetailsToggle.querySelectorAll("details").forEach((t=>{t.removeAttribute("open"),t.classList.remove("menu-opening")})),this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((t=>{t.classList.remove("submenu-open")})),document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),removeTrapFocus(e),this.closeAnimation(this.mainDetailsToggle))}onFocusOut(t){setTimeout((()=>{this.mainDetailsToggle.hasAttribute("open")&&!this.mainDetailsToggle.contains(document.activeElement)&&this.closeMenuDrawer()}))}onCloseButtonClick(t){const e=t.currentTarget.closest("details");this.closeSubmenu(e)}closeSubmenu(t){const e=t.closest(".submenu-open");e&&e.classList.remove("submenu-open"),t.classList.remove("menu-opening"),t.querySelector("summary").setAttribute("aria-expanded",!1),removeTrapFocus(t.querySelector("summary")),this.closeAnimation(t)}closeAnimation(t){let e;const i=s=>{void 0===e&&(e=s);s-e<400?window.requestAnimationFrame(i):(t.removeAttribute("open"),t.closest("details[open]")&&trapFocus(t.closest("details[open]"),t.querySelector("summary")))};window.requestAnimationFrame(i)}}customElements.define("menu-drawer",MenuDrawer);class HeaderDrawer extends MenuDrawer{constructor(){super()}openMenuDrawer(t){$(".menu-bar-item").addClass("active"),$(".account-bar-item").removeClass("active"),document.getElementById("account-menu").style.display="none",document.getElementById("main-menu").style.display="block",this.header=this.header||document.getElementById("shopify-section-header"),this.borderOffset=this.borderOffset||this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")?1:0,document.documentElement.style.setProperty("--header-bottom-position",`${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`),this.header.classList.add("menu-open"),setTimeout((()=>{this.mainDetailsToggle.classList.add("menu-opening")})),t.setAttribute("aria-expanded",!0),trapFocus(this.mainDetailsToggle,t),document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)}closeMenuDrawer(t,e){super.closeMenuDrawer(t,e),this.header.classList.remove("menu-open")}}customElements.define("header-drawer",HeaderDrawer);class ModalDialog extends HTMLElement{constructor(){super(),this.querySelector('[id^="ModalClose-"]').addEventListener("click",this.hide.bind(this,!1)),this.addEventListener("keyup",(t=>{"ESCAPE"===t.code.toUpperCase()&&this.hide()})),this.classList.contains("media-modal")?this.addEventListener("pointerup",(t=>{"mouse"!==t.pointerType||t.target.closest("deferred-media, product-model")||this.hide()})):this.addEventListener("click",(t=>{t.target===this&&this.hide()}))}connectedCallback(){this.moved||(this.moved=!0,document.body.appendChild(this))}show(t){this.openedBy=t;const e=this.querySelector(".template-popup");document.body.classList.add("overflow-hidden"),this.setAttribute("open",""),e&&e.loadContent(),trapFocus(this,this.querySelector('[role="dialog"]')),window.pauseAllMedia()}hide(){document.body.classList.remove("overflow-hidden"),document.body.dispatchEvent(new CustomEvent("modalClosed")),this.removeAttribute("open"),removeTrapFocus(this.openedBy),window.pauseAllMedia()}}customElements.define("modal-dialog",ModalDialog);class ModalOpener extends HTMLElement{constructor(){super();const t=this.querySelector("button");t&&t.addEventListener("click",(()=>{const e=document.querySelector(this.getAttribute("data-modal"));e&&e.show(t)}))}}customElements.define("modal-opener",ModalOpener);class DeferredMedia extends HTMLElement{constructor(){super();const t=this.querySelector('[id^="Deferred-Poster-"]');t&&t.addEventListener("click",this.loadContent.bind(this))}loadContent(t=!0){if(window.pauseAllMedia(),!this.getAttribute("loaded")){const e=document.createElement("div");e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),this.setAttribute("loaded",!0);const i=this.appendChild(e.querySelector("video, model-viewer, iframe"));t&&i.focus()}}}customElements.define("deferred-media",DeferredMedia);class SliderComponent extends HTMLElement{constructor(){if(super(),this.slider=this.querySelector('[id^="Slider-"]'),this.sliderItems=this.querySelectorAll('[id^="Slide-"]'),this.enableSliderLooping=!1,this.currentPageElement=this.querySelector(".slider-counter--current"),this.pageTotalElement=this.querySelector(".slider-counter--total"),this.prevButton=this.querySelector('button[name="previous"]'),this.nextButton=this.querySelector('button[name="next"]'),!this.slider||!this.nextButton)return;this.initPages();new ResizeObserver((t=>this.initPages())).observe(this.slider),this.slider.addEventListener("scroll",this.update.bind(this)),this.prevButton.addEventListener("click",this.onButtonClick.bind(this)),this.nextButton.addEventListener("click",this.onButtonClick.bind(this))}initPages(){this.sliderItemsToShow=Array.from(this.sliderItems).filter((t=>t.clientWidth>0)),this.sliderItemsToShow.length<2||(this.sliderItemOffset=this.sliderItemsToShow[1].offsetLeft-this.sliderItemsToShow[0].offsetLeft,this.slidesPerPage=Math.floor((this.slider.clientWidth-this.sliderItemsToShow[0].offsetLeft)/this.sliderItemOffset),this.totalPages=this.sliderItemsToShow.length-this.slidesPerPage+1,this.update())}resetPages(){this.sliderItems=this.querySelectorAll('[id^="Slide-"]'),this.initPages()}update(){const t=this.currentPage;this.currentPage=Math.round(this.slider.scrollLeft/this.sliderItemOffset)+1,this.currentPageElement&&this.pageTotalElement&&(this.currentPageElement.textContent=this.currentPage,this.pageTotalElement.textContent=this.totalPages),this.currentPage!=t&&this.dispatchEvent(new CustomEvent("slideChanged",{detail:{currentPage:this.currentPage,currentElement:this.sliderItemsToShow[this.currentPage-1]}})),this.enableSliderLooping||(this.isSlideVisible(this.sliderItemsToShow[0])&&0===this.slider.scrollLeft?this.prevButton.setAttribute("disabled","disabled"):this.prevButton.removeAttribute("disabled"),this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length-1])?this.nextButton.setAttribute("disabled","disabled"):this.nextButton.removeAttribute("disabled"))}isSlideVisible(t,e=0){const i=this.slider.clientWidth+this.slider.scrollLeft-e;return t.offsetLeft+t.clientWidth<=i&&t.offsetLeft>=this.slider.scrollLeft}onButtonClick(t){console.log("aa");const e=t.currentTarget.dataset.step||1;this.slideScrollPosition="next"===t.currentTarget.name?this.slider.scrollLeft+e*this.sliderItemOffset:this.slider.scrollLeft-e*this.sliderItemOffset,this.slider.scrollTo({left:this.slideScrollPosition})}}customElements.define("slider-component",SliderComponent);class SlideshowComponent extends SliderComponent{constructor(){super(),this.sliderControlWrapper=this.querySelector(".slider-buttons"),this.enableSliderLooping=!0,this.sliderControlWrapper&&(this.sliderFirstItemNode=this.slider.querySelector(".slideshow__slide"),this.sliderItemsToShow.length>0&&(this.currentPage=1),this.sliderControlLinksArray=Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link")),this.sliderControlLinksArray.forEach((t=>t.addEventListener("click",this.linkToSlide.bind(this)))),this.slider.addEventListener("scroll",this.setSlideVisibility.bind(this)),this.setSlideVisibility(),"true"===this.slider.getAttribute("data-autoplay")&&this.setAutoPlay())}setAutoPlay(){this.sliderAutoplayButton=this.querySelector(".slideshow__autoplay"),this.autoplaySpeed=1e3*this.slider.dataset.speed,this.sliderAutoplayButton.addEventListener("click",this.autoPlayToggle.bind(this)),this.addEventListener("mouseover",this.focusInHandling.bind(this)),this.addEventListener("mouseleave",this.focusOutHandling.bind(this)),this.addEventListener("focusin",this.focusInHandling.bind(this)),this.addEventListener("focusout",this.focusOutHandling.bind(this)),this.play(),this.autoplayButtonIsSetToPlay=!0}onButtonClick(t){super.onButtonClick(t);const e=1===this.currentPage,i=this.currentPage===this.sliderItemsToShow.length;(e||i)&&(e&&"previous"===t.currentTarget.name?this.slideScrollPosition=this.slider.scrollLeft+this.sliderFirstItemNode.clientWidth*this.sliderItemsToShow.length:i&&"next"===t.currentTarget.name&&(this.slideScrollPosition=0),this.slider.scrollTo({left:this.slideScrollPosition}))}update(){super.update(),this.sliderControlButtons=this.querySelectorAll(".slider-counter__link"),this.prevButton.removeAttribute("disabled"),this.sliderControlButtons.length&&(this.sliderControlButtons.forEach((t=>{t.classList.remove("slider-counter__link--active"),t.removeAttribute("aria-current")})),this.sliderControlButtons[this.currentPage-1].classList.add("slider-counter__link--active"),this.sliderControlButtons[this.currentPage-1].setAttribute("aria-current",!0))}autoPlayToggle(){this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),this.autoplayButtonIsSetToPlay?this.pause():this.play(),this.autoplayButtonIsSetToPlay=!this.autoplayButtonIsSetToPlay}focusOutHandling(t){const e=t.target===this.sliderAutoplayButton||this.sliderAutoplayButton.contains(t.target);this.autoplayButtonIsSetToPlay&&!e&&this.play()}focusInHandling(t){(t.target===this.sliderAutoplayButton||this.sliderAutoplayButton.contains(t.target))&&this.autoplayButtonIsSetToPlay?this.play():this.autoplayButtonIsSetToPlay&&this.pause()}play(){this.slider.setAttribute("aria-live","off"),clearInterval(this.autoplay),this.autoplay=setInterval(this.autoRotateSlides.bind(this),this.autoplaySpeed)}pause(){this.slider.setAttribute("aria-live","polite"),clearInterval(this.autoplay)}togglePlayButtonState(t){t?(this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),this.sliderAutoplayButton.setAttribute("aria-label",window.accessibilityStrings.playSlideshow)):(this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"),this.sliderAutoplayButton.setAttribute("aria-label",window.accessibilityStrings.pauseSlideshow))}autoRotateSlides(){const t=this.currentPage===this.sliderItems.length?0:this.slider.scrollLeft+this.slider.querySelector(".slideshow__slide").clientWidth;this.slider.scrollTo({left:t})}setSlideVisibility(){this.sliderItemsToShow.forEach(((t,e)=>{const i=t.querySelector("a");e===this.currentPage-1?(i&&i.removeAttribute("tabindex"),t.setAttribute("aria-hidden","false"),t.removeAttribute("tabindex")):(i&&i.setAttribute("tabindex","-1"),t.setAttribute("aria-hidden","true"),t.setAttribute("tabindex","-1"))}))}linkToSlide(t){t.preventDefault();const e=this.slider.scrollLeft+this.sliderFirstItemNode.clientWidth*(this.sliderControlLinksArray.indexOf(t.currentTarget)+1-this.currentPage);this.slider.scrollTo({left:e})}}customElements.define("slideshow-component",SlideshowComponent);class VariantSelects extends HTMLElement{constructor(){super(),this.addEventListener("change",this.onVariantChange)}onVariantChange(){this.updateOptions(),this.updateMasterId(),this.toggleAddButton(!0,"",!1),this.updatePickupAvailability(),this.removeErrorMessage(),this.currentVariant?(this.updateMedia(),this.updateURL(),this.updateVariantInput(),this.renderProductInfo(),this.updateShareUrl()):(this.toggleAddButton(!0,"",!0),this.setUnavailable())}updateOptions(){this.options=Array.from(this.querySelectorAll("select"),(t=>t.value))}updateMasterId(){this.currentVariant=this.getVariantData().find((t=>!t.options.map(((t,e)=>this.options[e]===t)).includes(!1)))}updateMedia(){if(!this.currentVariant)return;if(!this.currentVariant.featured_media)return;var t=$(".slider-nav").find(`li[data-target="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`).attr("data-media-position");$(".slider-nav").slick("slickGoTo",t-1);const e=document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);if(!e)return;const i=e.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);e.prepend(i)}updateURL(){this.currentVariant&&"false"!==this.dataset.updateUrl&&window.history.replaceState({},"",`${this.dataset.url}?variant=${this.currentVariant.id}`)}updateShareUrl(){const t=document.getElementById(`Share-${this.dataset.section}`);t&&t.updateUrl&&t.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)}updateVariantInput(){document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((t=>{const e=t.querySelector('input[name="id"]');e.value=this.currentVariant.id,e.dispatchEvent(new Event("change",{bubbles:!0}))}))}updatePickupAvailability(){const t=document.querySelector("pickup-availability");t&&(this.currentVariant&&this.currentVariant.available?t.fetchAvailability(this.currentVariant.id):(t.removeAttribute("available"),t.innerHTML=""))}removeErrorMessage(){const t=this.closest("section");if(!t)return;const e=t.querySelector("product-form");e&&e.handleErrorMessage()}renderProductInfo(){fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`).then((t=>t.text())).then((t=>{const e=(new DOMParser).parseFromString(t,"text/html"),i=document.getElementById(`price-${this.dataset.section}`),s=e.getElementById(`price-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`);s&&i&&(i.innerHTML=s.innerHTML);const o=document.getElementById(`price-${this.dataset.section}`);$(".sku-unit").length>0&&$(".sku-unit").text(this.currentVariant.sku),$(".genoapay_payment_method .installment_price").html(Shopify.formatMoney(Math.round(this.currentVariant.price/10*100)/100,"NZ${{amount}}")),$(".laybuy_payment_method .installment_price").html(Shopify.formatMoney(Math.round(this.currentVariant.price/6*100)/100,"NZ${{amount}}")),$(".afterpay_payment_method .installment_price").html(Shopify.formatMoney(Math.round(this.currentVariant.price/4*100)/100,"NZ${{amount}}")),$(".zip_payment_method .installment_price").html(Shopify.formatMoney(Math.round(this.currentVariant.price/4*100)/100,"NZ${{amount}}")),o&&o.classList.remove("visibility-hidden"),this.toggleAddButton(!this.currentVariant.available,window.variantStrings.soldOut)}))}toggleAddButton(t=!0,e,i=!0){const s=document.getElementById(`product-form-${this.dataset.section}`);if(!s)return;const o=s.querySelector('[name="add"]'),n=s.querySelector('[name="add"] > span');o&&(t?(o.setAttribute("disabled","disabled"),e&&(n.textContent=e)):(o.removeAttribute("disabled"),n.textContent=window.variantStrings.addToCart))}setUnavailable(){const t=document.getElementById(`product-form-${this.dataset.section}`),e=t.querySelector('[name="add"]'),i=t.querySelector('[name="add"] > span'),s=document.getElementById(`price-${this.dataset.section}`);e&&(i.textContent=window.variantStrings.unavailable,s&&s.classList.add("visibility-hidden"))}getVariantData(){return this.variantData=this.variantData||JSON.parse(this.querySelector('[type="application/json"]').textContent),this.variantData}}customElements.define("variant-selects",VariantSelects);class VariantRadios extends VariantSelects{constructor(){super()}updateOptions(){const t=Array.from(this.querySelectorAll("fieldset"));this.options=t.map((t=>Array.from(t.querySelectorAll("input")).find((t=>t.checked)).value))}}function isMobile(){var t,e=!1;return t=navigator.userAgent||navigator.vendor||window.opera,(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0,4)))&&(e=!0),e}function addEvent(t,e,i){t.addEventListener?t.addEventListener(e,i,!1):t.attachEvent&&t.attachEvent("on"+e,i)}function updateOfferCount(){var t=0;$.ajax({type:"GET",url:"/cart.js",cache:!1,dataType:"json",async:!1,success:function(e){0==e.item_count&&localStorage.removeItem("show-protectors"),$.each(e.items,(function(e,i){"yes"==getProductTag(i.handle)&&(t=parseInt(t)+parseInt(i.quantity))}));var i=parseInt(localStorage.getItem("screen-protectors"));localStorage.setItem("screen-protectors",t),1==parseInt(localStorage.getItem("screen-protectors"))&&0==i&&null===localStorage.getItem("show-protectors")?($("#popup-discount").show(),localStorage.setItem("show-protectors",1)):(console.log(null===localStorage.getItem("show-protectors")),$("#popup-discount").hide())},done:function(){var e=parseInt(localStorage.getItem("screen-protectors"));localStorage.setItem("screen-protectors",t),1==parseInt(localStorage.getItem("screen-protectors"))&&0==e&&null===localStorage.getItem("show-protectors")?($("#popup-discount").show(),localStorage.setItem("show-protectors",1)):(console.log(null===localStorage.getItem("show-protectors")),$("#popup-discount").hide())}})}customElements.define("variant-radios",VariantRadios),$(document).ready((function(){setTimeout((function(){""==$(".stamped-product-reviews-badge .stamped-badge-caption").html()&&$(".stamped-product-reviews-badge .stamped-badge-caption").html("0 Reviews")}),2e3),$(".stamped-main-badge").click((function(){$("#reviewss .accordion").hasClass("active")||($("#reviewss .accordion").addClass("active"),$("#reviewss .panel.content").show()),setTimeout((function(){$("html, body").animate({scrollTop:$("#reviewss").offset().top},1e3)}),500)})),$("#choose_variants .swatch-element  input").click((function(){var t=$(this).parents(".swatch-element").find(".fbt-variant-sku").data("val"),e=$(this).val();$(this).parents(".freq-block").find(".pd-name .pd-block").text(t);var i=$(this).parents(".swatch").prev().prev().find('.frequently_variant_select option[value="'+e+'"]');$(this).parents(".swatch").prev().prev().find(".frequently_variant_select option").attr("selected",!1),$(i).attr("selected",!0)})),"true"==localStorage.getItem("terms_and_conditions")?($("#agree").prop("checked",!0),$("span#terms_text_cart").html("I've read and agree to the"),$("#shopping-cart #dynamic-checkout-cart").show(),$("span#terms_text").html("I've read and agree to the"),$("#checkout").show(),$("#checkout_placeholder").hide(),$("#cart_checkout_placeholder").hide(),$("#cart_checkout").show()):($("#agree").prop("checked",!1),$("#shopping-cart #dynamic-checkout-cart").hide(),$("span#terms_text_cart").html("I agree to"),$("span#terms_text").html("I agree to"),$("#checkout").hide(),$("#checkout_placeholder").show(),$("#cart_checkout_placeholder").show(),$("#cart_checkout").hide()),$(document).on("click","#agree",(function(){$("#agree").is(":checked")?($("span#terms_text").html("I've read and agree to the"),$("span#terms_text_cart").html("I've read and agree to the"),localStorage.setItem("terms_and_conditions","true"),$("#shopping-cart #dynamic-checkout-cart").show(),$("#checkout").show(),$("#checkout_placeholder").hide(),$("#cart_checkout_placeholder").hide(),$("#cart_checkout").show()):(localStorage.setItem("terms_and_conditions","false"),$("#shopping-cart #dynamic-checkout-cart").hide(),$("span#terms_text_cart").html("I agree to"),$("span#terms_text").html("I agree to"),$("#checkout").hide(),$("#checkout_placeholder").show(),$("#cart_checkout_placeholder").show(),$("#cart_checkout").hide())})),$("#checkout_placeholder").click((function(){$("#terms_error").addClass("show-pop")})),$(".close-popup").click((function(){$("#terms_error").removeClass("show-pop")}))})),addEvent(document,"mouseout",(function(t){null==t.toElement&&null==t.relatedTarget&&(parseInt($("body .cart-count").html())<1||$(".exit-popup").hasClass("displayed-once")||"yes"==localStorage.getItem("exit-popup")||($(".exit-popup").addClass("show-exitpopup"),$(".exit-popup").addClass("displayed-once"),localStorage.setItem("exit-popup","yes")))})),$(document).ready((function(){$("span.close-exitpopup").click((function(){$(".exit-popup").removeClass("show-exitpopup")})),"yes"!=localStorage.getItem("exit-popup")?$(".exit-popup").removeClass("displayed-once"):$(".exit-popup").addClass("displayed-once")})),window.onload=function(){isMobile()&&(window.history&&history.pushState?(null==history.state&&history.pushState({status:"ongoing"},null,null),window.onpopstate=function(t){parseInt($("body .cart-count").html())<1||$(".exit-popup").hasClass("displayed-once")||"yes"==localStorage.getItem("exit-popup")||($(".exit-popup").addClass("show-exitpopup"),$(".exit-popup").addClass("displayed-once"),history.pushState(null,null,null),localStorage.setItem("exit-popup","yes"))}):$(".exit-popup").removeClass("show-exitpopup"))},$(document).ready((function(){var t=0;$.ajax({type:"GET",url:"/cart.js",cache:!1,dataType:"json",async:!1,success:function(e){0==e.item_count&&localStorage.removeItem("show-protectors"),$.each(e.items,(function(e,i){var s,o;s=i.handle,o="",$.ajax({type:"GET",url:"/products/"+s+".js",cache:!1,dataType:"json",async:!1,success:function(t){var e=t.tags;o=e.includes("Screen Protectors")?"yes":"no"}}),"yes"==o&&(t=parseInt(t)+parseInt(i.quantity))}));parseInt(localStorage.getItem("screen-protectors"));localStorage.setItem("screen-protectors",t),parseInt(localStorage.getItem("screen-protectors"))%2==1?($("#shopping-cart .offer_cart_notification").html('Add another protector for 20% off <span class="close-notif">X</span>'),$("#shopping-cart .offer_cart_notification").show()):($("#shopping-cart .offer_cart_notification").html(""),$("#shopping-cart .offer_cart_notification").hide())},done:function(){localStorage.setItem("screen-protectors",t),parseInt(localStorage.getItem("screen-protectors"))%2==1?($("#shopping-cart .offer_cart_notification").html('Add another protector for 20% off <span class="close-notif">X</span>'),$("#shopping-cart .offer_cart_notification").show()):($("#shopping-cart .offer_cart_notification").html(""),$("#shopping-cart .offer_cart_notification").hide())}}),$(document).on("click",".close-notif",(function(){$(".offer_cart_notification").hide()})),$(".close-popupoff").on("click",(function(){$(".popup-discount").addClass("hidepopup"),$("#popup-discount").hide()}))})),$(document).ready((function(){if($("body").hasClass("tdf-product-page")){var t=$(".price__regular").attr("data-price");$(".genoapay_payment_method .installment_price").html(Shopify.formatMoney(Math.round(t/10*100)/100,"NZ${{amount}}")),$(".laybuy_payment_method .installment_price").html(Shopify.formatMoney(Math.round(t/6*100)/100,"NZ${{amount}}")),$(".afterpay_payment_method .installment_price").html(Shopify.formatMoney(Math.round(t/4*100)/100,"NZ${{amount}}")),$(".zip_payment_method .installment_price").html(Shopify.formatMoney(Math.round(t/4*100)/100,"NZ${{amount}}"))}})),$(document).ready((function(){function t(){$('[rel="lazy-stylesheet"]').length>0&&$.each($('[rel="lazy-stylesheet"]'),(function(){$(this).attr("rel","stylesheet")}))}function e(){$('[rel="lazy-clickable"]').length>0&&$.each($('[rel="lazy-clickable"]'),(function(){$(this).attr("rel","stylesheet")}))}$(window).one("scroll",(function(){t(),e()})),$(window).on("load",(function(){let i=document.documentElement.scrollTop;console.log(i),0!=i&&(t(),e()),console.log("fdsd"),console.log($("ul.collection-page-swatch li")),$(document).on("click","ul.collection-page-swatch li",(function(t){$(this).closest(".product-index").find(".collection-page-swatch li").removeClass("checkedSwatch"),jQuery(this).addClass("checkedSwatch");var e=$(this).data("variant-id"),i=$(this).data("variant_image"),s=$(this).closest(".product-index"),o=$(this).data("variant_price");s.find(".prod-image a img").attr("src",i),s.find(".price__container .price__regular .price-item--regular").text("NZ$"+o),s.find('.product-form input[name="id"]').val(e),s.find('.product-form input[name="id"]').attr("id",e),console.log(e)}))})),$(".product-size__chart a").click((function(){e()}))}));

function getFocusableElements(t) {
    return Array.from(t.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}
document.querySelectorAll('[id^="Details-"] summary').forEach((t => {
    t.setAttribute("role", "button"),
    t.setAttribute("aria-expanded", t.parentNode.hasAttribute("open")),
    t.nextElementSibling.getAttribute("id") && t.setAttribute("aria-controls", t.nextElementSibling.id),
    t.addEventListener("click", (t => {
        t.currentTarget.setAttribute("aria-expanded", !t.currentTarget.closest("details").hasAttribute("open"))
    }
    )),
    t.closest("header-drawer") || t.parentElement.addEventListener("keyup", onKeyUpEscape)
}
));
const trapFocusHandlers = {};
function trapFocus(t, e=t) {
    var i = getFocusableElements(t)
      , s = i[0]
      , o = i[i.length - 1];
    removeTrapFocus(),
    trapFocusHandlers.focusin = e => {
        e.target !== t && e.target !== o && e.target !== s || document.addEventListener("keydown", trapFocusHandlers.keydown)
    }
    ,
    trapFocusHandlers.focusout = function() {
        document.removeEventListener("keydown", trapFocusHandlers.keydown)
    }
    ,
    trapFocusHandlers.keydown = function(e) {
        "TAB" === e.code.toUpperCase() && (e.target !== o || e.shiftKey || (e.preventDefault(),
        s.focus()),
        e.target !== t && e.target !== s || !e.shiftKey || (e.preventDefault(),
        o.focus()))
    }
    ,
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    e.focus()
}
try {
    document.querySelector(":focus-visible")
} catch (t) {
    focusVisiblePolyfill()
}
function focusVisiblePolyfill() {
    const t = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
    let e = null
      , i = null;
    window.addEventListener("keydown", (e => {
        t.includes(e.code.toUpperCase()) && (i = !1)
    }
    )),
    window.addEventListener("mousedown", (t => {
        i = !0
    }
    )),
    window.addEventListener("focus", ( () => {
        e && e.classList.remove("focused"),
        i || (e = document.activeElement,
        e.classList.add("focused"))
    }
    ), !0)
}
function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((t => {
        t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
    }
    )),
    document.querySelectorAll(".js-vimeo").forEach((t => {
        t.contentWindow.postMessage('{"method":"pause"}', "*")
    }
    )),
    document.querySelectorAll("video").forEach((t => t.pause())),
    document.querySelectorAll("product-model").forEach((t => {
        t.modelViewerUI && t.modelViewerUI.pause()
    }
    ))
}
function removeTrapFocus(t=null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    t && t.focus()
}
function onKeyUpEscape(t) {
    if ("ESCAPE" !== t.code.toUpperCase())
        return;
    const e = t.target.closest("details[open]");
    if (!e)
        return;
    const i = e.querySelector("summary");
    e.removeAttribute("open"),
    i.setAttribute("aria-expanded", !1),
    i.focus()
}
class QuantityInput extends HTMLElement {
    constructor() {
        super(),
        this.input = this.querySelector("input"),
        this.changeEvent = new Event("change",{
            bubbles: !0
        }),
        this.querySelectorAll("button").forEach((t => t.addEventListener("click", this.onButtonClick.bind(this))))
    }
    onButtonClick(t) {
        t.preventDefault();
        const e = this.input.value;
        "plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(),
        e !== this.input.value && this.input.dispatchEvent(this.changeEvent)
    }
}
function debounce(t, e) {
    let i;
    return (...s) => {
        clearTimeout(i),
        i = setTimeout(( () => t.apply(this, s)), e)
    }
}
function fetchConfig(t="json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${t}`
        }
    }
}
customElements.define("quantity-input", QuantityInput),
void 0 === window.Shopify && (window.Shopify = {}),
Shopify.bind = function(t, e) {
    return function() {
        return t.apply(e, arguments)
    }
}
,
Shopify.setSelectorByValue = function(t, e) {
    for (var i = 0, s = t.options.length; i < s; i++) {
        var o = t.options[i];
        if (e == o.value || e == o.innerHTML)
            return t.selectedIndex = i,
            i
    }
}
,
Shopify.addListener = function(t, e, i) {
    t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i)
}
,
Shopify.postLink = function(t, e) {
    var i = (e = e || {}).method || "post"
      , s = e.parameters || {}
      , o = document.createElement("form");
    for (var n in o.setAttribute("method", i),
    o.setAttribute("action", t),
    s) {
        var a = document.createElement("input");
        a.setAttribute("type", "hidden"),
        a.setAttribute("name", n),
        a.setAttribute("value", s[n]),
        o.appendChild(a)
    }
    document.body.appendChild(o),
    o.submit(),
    document.body.removeChild(o)
}
,
Shopify.CountryProvinceSelector = function(t, e, i) {
    this.countryEl = document.getElementById(t),
    this.provinceEl = document.getElementById(e),
    this.provinceContainer = document.getElementById(i.hideElement || e),
    Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
    this.initCountry(),
    this.initProvince()
}
,
Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var t = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, t),
        this.countryHandler()
    },
    initProvince: function() {
        var t = this.provinceEl.getAttribute("data-default");
        t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t)
    },
    countryHandler: function(t) {
        var e = (o = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces")
          , i = JSON.parse(e);
        if (this.clearOptions(this.provinceEl),
        i && 0 == i.length)
            this.provinceContainer.style.display = "none";
        else {
            for (var s = 0; s < i.length; s++) {
                var o;
                (o = document.createElement("option")).value = i[s][0],
                o.innerHTML = i[s][1],
                this.provinceEl.appendChild(o)
            }
            this.provinceContainer.style.display = ""
        }
    },
    clearOptions: function(t) {
        for (; t.firstChild; )
            t.removeChild(t.firstChild)
    },
    setOptions: function(t, e) {
        var i = 0;
        for (e.length; i < e.length; i++) {
            var s = document.createElement("option");
            s.value = e[i],
            s.innerHTML = e[i],
            t.appendChild(s)
        }
    }
};
class MenuDrawer extends HTMLElement {
    constructor() {
        super(),
        this.mainDetailsToggle = this.querySelector("details"),
        "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`),
        this.addEventListener("keyup", this.onKeyUp.bind(this)),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.bindEvents()
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((t => t.addEventListener("click", this.onSummaryClick.bind(this)))),
        this.querySelectorAll("button").forEach((t => t.addEventListener("click", this.onCloseButtonClick.bind(this))))
    }
    onKeyUp(t) {
        if ("ESCAPE" !== t.code.toUpperCase())
            return;
        const e = t.target.closest("details[open]");
        e && (e === this.mainDetailsToggle ? this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(e))
    }
    onSummaryClick(t) {
        const e = t.currentTarget
          , i = e.parentNode
          , s = i.closest(".has-submenu")
          , o = i.hasAttribute("open")
          , n = window.matchMedia("(prefers-reduced-motion: reduce)");
        function a() {
            trapFocus(e.nextElementSibling, i.querySelector("button")),
            e.nextElementSibling.removeEventListener("transitionend", a)
        }
        i === this.mainDetailsToggle ? (o && t.preventDefault(),
        o ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e)) : setTimeout(( () => {
            i.classList.add("menu-opening"),
            e.setAttribute("aria-expanded", !0),
            s && s.classList.add("submenu-open"),
            !n || n.matches ? a() : e.nextElementSibling.addEventListener("transitionend", a)
        }
        ), 100)
    }
    openMenuDrawer(t) {
        setTimeout(( () => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }
        )),
        t.setAttribute("aria-expanded", !0),
        trapFocus(this.mainDetailsToggle, t),
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(t, e=!1) {
        void 0 !== t && (this.mainDetailsToggle.classList.remove("menu-opening"),
        this.mainDetailsToggle.querySelectorAll("details").forEach((t => {
            t.removeAttribute("open"),
            t.classList.remove("menu-opening")
        }
        )),
        this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((t => {
            t.classList.remove("submenu-open")
        }
        )),
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
        removeTrapFocus(e),
        this.closeAnimation(this.mainDetailsToggle))
    }
    onFocusOut(t) {
        setTimeout(( () => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
        }
        ))
    }
    onCloseButtonClick(t) {
        const e = t.currentTarget.closest("details");
        this.closeSubmenu(e)
    }
    closeSubmenu(t) {
        const e = t.closest(".submenu-open");
        e && e.classList.remove("submenu-open"),
        t.classList.remove("menu-opening"),
        t.querySelector("summary").setAttribute("aria-expanded", !1),
        removeTrapFocus(t.querySelector("summary")),
        this.closeAnimation(t)
    }
    closeAnimation(t) {
        let e;
        const i = s => {
            void 0 === e && (e = s);
            s - e < 400 ? window.requestAnimationFrame(i) : (t.removeAttribute("open"),
            t.closest("details[open]") && trapFocus(t.closest("details[open]"), t.querySelector("summary")))
        }
        ;
        window.requestAnimationFrame(i)
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super()
    }
    openMenuDrawer(t) {
        $(".menu-bar-item").addClass("active"),
        $(".account-bar-item").removeClass("active"),
        document.getElementById("account-menu").style.display = "none",
        document.getElementById("main-menu").style.display = "block",
        this.header = this.header || document.getElementById("shopify-section-header"),
        this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0,
        document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`),
        this.header.classList.add("menu-open"),
        setTimeout(( () => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }
        )),
        t.setAttribute("aria-expanded", !0),
        trapFocus(this.mainDetailsToggle, t),
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(t, e) {
        super.closeMenuDrawer(t, e),
        this.header.classList.remove("menu-open")
    }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super(),
        this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)),
        this.addEventListener("keyup", (t => {
            "ESCAPE" === t.code.toUpperCase() && this.hide()
        }
        )),
        this.classList.contains("media-modal") ? this.addEventListener("pointerup", (t => {
            "mouse" !== t.pointerType || t.target.closest("deferred-media, product-model") || this.hide()
        }
        )) : this.addEventListener("click", (t => {
            t.target === this && this.hide()
        }
        ))
    }
    connectedCallback() {
        this.moved || (this.moved = !0,
        document.body.appendChild(this))
    }
    show(t) {
        this.openedBy = t;
        const e = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"),
        this.setAttribute("open", ""),
        e && e.loadContent(),
        trapFocus(this, this.querySelector('[role="dialog"]')),
        window.pauseAllMedia()
    }
    hide() {
        document.body.classList.remove("overflow-hidden"),
        document.body.dispatchEvent(new CustomEvent("modalClosed")),
        this.removeAttribute("open"),
        removeTrapFocus(this.openedBy),
        window.pauseAllMedia()
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        const t = this.querySelector("button");
        t && t.addEventListener("click", ( () => {
            const e = document.querySelector(this.getAttribute("data-modal"));
            e && e.show(t)
        }
        ))
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const t = this.querySelector('[id^="Deferred-Poster-"]');
        t && t.addEventListener("click", this.loadContent.bind(this))
    }
    loadContent(t=!0) {
        if (window.pauseAllMedia(),
        !this.getAttribute("loaded")) {
            const e = document.createElement("div");
            e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),
            this.setAttribute("loaded", !0);
            const i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
            t && i.focus()
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
    constructor() {
        if (super(),
        this.slider = this.querySelector('[id^="Slider-"]'),
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]'),
        this.enableSliderLooping = !1,
        this.currentPageElement = this.querySelector(".slider-counter--current"),
        this.pageTotalElement = this.querySelector(".slider-counter--total"),
        this.prevButton = this.querySelector('button[name="previous"]'),
        this.nextButton = this.querySelector('button[name="next"]'),
        !this.slider || !this.nextButton)
            return;
        this.initPages();
        new ResizeObserver((t => this.initPages())).observe(this.slider),
        this.slider.addEventListener("scroll", this.update.bind(this)),
        this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
        this.nextButton.addEventListener("click", this.onButtonClick.bind(this))
    }
    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((t => t.clientWidth > 0)),
        this.sliderItemsToShow.length < 2 || (this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft,
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset),
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1,
        this.update())
    }
    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]'),
        this.initPages()
    }
    update() {
        const t = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1,
        this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage,
        this.pageTotalElement.textContent = this.totalPages),
        this.currentPage != t && this.dispatchEvent(new CustomEvent("slideChanged",{
            detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }
        })),
        this.enableSliderLooping || (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"))
    }
    isSlideVisible(t, e=0) {
        const i = this.slider.clientWidth + this.slider.scrollLeft - e;
        return t.offsetLeft + t.clientWidth <= i && t.offsetLeft >= this.slider.scrollLeft
    }
    onButtonClick(t) {
        const e = t.currentTarget.dataset.step || 1;
        this.slideScrollPosition = "next" === t.currentTarget.name ? this.slider.scrollLeft + e * this.sliderItemOffset : this.slider.scrollLeft - e * this.sliderItemOffset,
        this.slider.scrollTo({
            left: this.slideScrollPosition
        })
    }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
    constructor() {
        super(),
        this.sliderControlWrapper = this.querySelector(".slider-buttons"),
        this.enableSliderLooping = !0,
        this.sliderControlWrapper && (this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide"),
        this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link")),
        this.sliderControlLinksArray.forEach((t => t.addEventListener("click", this.linkToSlide.bind(this)))),
        this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)),
        this.setSlideVisibility(),
        "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay())
    }
    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay"),
        this.autoplaySpeed = 1e3 * this.slider.dataset.speed,
        this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)),
        this.addEventListener("mouseover", this.focusInHandling.bind(this)),
        this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
        this.addEventListener("focusin", this.focusInHandling.bind(this)),
        this.addEventListener("focusout", this.focusOutHandling.bind(this)),
        this.play(),
        this.autoplayButtonIsSetToPlay = !0
    }
    onButtonClick(t) {
        super.onButtonClick(t);
        const e = 1 === this.currentPage
          , i = this.currentPage === this.sliderItemsToShow.length;
        (e || i) && (e && "previous" === t.currentTarget.name ? this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length : i && "next" === t.currentTarget.name && (this.slideScrollPosition = 0),
        this.slider.scrollTo({
            left: this.slideScrollPosition
        }))
    }
    update() {
        super.update(),
        this.sliderControlButtons = this.querySelectorAll(".slider-counter__link"),
        this.prevButton.removeAttribute("disabled"),
        this.sliderControlButtons.length && (this.sliderControlButtons.forEach((t => {
            t.classList.remove("slider-counter__link--active"),
            t.removeAttribute("aria-current")
        }
        )),
        this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"),
        this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0))
    }
    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
    }
    focusOutHandling(t) {
        const e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
        this.autoplayButtonIsSetToPlay && !e && this.play()
    }
    focusInHandling(t) {
        (t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target)) && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause()
    }
    play() {
        this.slider.setAttribute("aria-live", "off"),
        clearInterval(this.autoplay),
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
    }
    pause() {
        this.slider.setAttribute("aria-live", "polite"),
        clearInterval(this.autoplay)
    }
    togglePlayButtonState(t) {
        t ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)) : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow))
    }
    autoRotateSlides() {
        const t = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
        this.slider.scrollTo({
            left: t
        })
    }
    setSlideVisibility() {
        this.sliderItemsToShow.forEach(( (t, e) => {
            const i = t.querySelector("a");
            e === this.currentPage - 1 ? (i && i.removeAttribute("tabindex"),
            t.setAttribute("aria-hidden", "false"),
            t.removeAttribute("tabindex")) : (i && i.setAttribute("tabindex", "-1"),
            t.setAttribute("aria-hidden", "true"),
            t.setAttribute("tabindex", "-1"))
        }
        ))
    }
    linkToSlide(t) {
        t.preventDefault();
        const e = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: e
        })
    }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
    constructor() {
        super(),
        this.addEventListener("change", this.onVariantChange)
    }
    onVariantChange() {
        this.updateOptions(),
        this.updateMasterId(),
        this.toggleAddButton(!0, "", !1),
        this.updatePickupAvailability(),
        this.removeErrorMessage(),
        this.currentVariant ? (this.updateMedia(),                    
        this.updateURL(),
        this.updateVariantInput(),
        this.renderProductInfo(),
        this.updateShareUrl()) : (this.toggleAddButton(!0, "", !0),
        this.setUnavailable())
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (t => t.value))
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((t => !t.options.map(( (t, e) => this.options[e] === t)).includes(!1)))
    }
    updateMedia() {
        if (!this.currentVariant)
            return;
        if (!this.currentVariant.featured_media)
            return;
        var t = $(".slider-nav").find(`li[data-target="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`).attr("data-media-position");
        $(".slider-nav").slick("slickGoTo", t - 1);
        const e = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!e)
            return;
        const i = e.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        e.prepend(i)
    }
    updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
    updateShareUrl() {
        const t = document.getElementById(`Share-${this.dataset.section}`);
        t && t.updateUrl && t.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
    updateVariantInput() {
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((t => {
            const e = t.querySelector('input[name="id"]');
            e.value = this.currentVariant.id,
            e.dispatchEvent(new Event("change",{
                bubbles: !0
            }))
        }
        ))
      
          try {
    const links = document.querySelectorAll('.main-product-outer .slider-mobile-gutter .iWishAddColl');
    if (!links.length) return;

    links.forEach((link) => {
        link.setAttribute('data-variant', this.currentVariant?.id || '');
        link.classList.add('iwishcheck');
    });

    if (typeof iWish !== 'undefined' && typeof iWish.checkIwishColl === 'function') {
        iWish.checkIwishColl();
    }
} catch (error) {
    console.error(error);
}
 
    }
    updatePickupAvailability() {
        const t = document.querySelector("pickup-availability");
        t && (this.currentVariant && this.currentVariant.available ? t.fetchAvailability(this.currentVariant.id) : (t.removeAttribute("available"),
        t.innerHTML = ""))
    }
    removeErrorMessage() {
        const t = this.closest("section");
        if (!t)
            return;
        const e = t.querySelector("product-form");
        e && e.handleErrorMessage()
    }
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`).then((t => t.text())).then((t => {
            const e = (new DOMParser).parseFromString(t, "text/html")
              , i = document.getElementById(`price-${this.dataset.section}`)
              , s = e.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            s && i && (i.innerHTML = s.innerHTML);
            const o = document.getElementById(`price-${this.dataset.section}`);
            $(".sku-unit").length > 0 && $(".sku-unit").text(this.currentVariant.sku),
            $(".genoapay_payment_method .installment_price").html(Shopify.formatMoney(Math.round(this.currentVariant.price / 10 * 100) / 100, "NZ${{amount}}")),
            $(".laybuy_payment_method .installment_price").html(Shopify.formatMoney(Math.round(this.currentVariant.price / 6 * 100) / 100, "NZ${{amount}}")),
            $(".afterpay_payment_method .installment_price").html(Shopify.formatMoney(Math.round(this.currentVariant.price / 4 * 100) / 100, "NZ${{amount}}")),
            $(".zip_payment_method .installment_price").html(Shopify.formatMoney(Math.round(this.currentVariant.price / 4 * 100) / 100, "NZ${{amount}}")),
            o && o.classList.remove("visibility-hidden"),
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
        }
        ))
    }
    toggleAddButton(t=!0, e, i=!0) {
        const s = document.getElementById(`product-form-${this.dataset.section}`);
        if (!s)
            return;
        const o = s.querySelector('[name="add"]')
          , n = s.querySelector('[name="add"] > span');
        o && (t ? (o.setAttribute("disabled", "disabled"),
        e && (n.textContent = e)) : (o.removeAttribute("disabled"),
        n.textContent = window.variantStrings.addToCart))
    }
    setUnavailable() {
        const t = document.getElementById(`product-form-${this.dataset.section}`)
          , e = t.querySelector('[name="add"]')
          , i = t.querySelector('[name="add"] > span')
          , s = document.getElementById(`price-${this.dataset.section}`);
        e && (i.textContent = window.variantStrings.unavailable,
        s && s.classList.add("visibility-hidden"))
    }
    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent),
        this.variantData
    }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super()
    }
    updateOptions() {
        const t = Array.from(this.querySelectorAll("fieldset"));
        this.options = t.map((t => Array.from(t.querySelectorAll("input")).find((t => t.checked)).value))
    }
}
function isMobile() {
    var t, e = !1;
    return t = navigator.userAgent || navigator.vendor || window.opera,
    (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = !0),
    e
}
function addEvent(t, e, i) {
    t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent && t.attachEvent("on" + e, i)
}
function updateOfferCount() {
    var t = 0;
    $.ajax({
        type: "GET",
        url: "/cart.js",
        cache: !1,
        dataType: "json",
        async: !1,
        success: function(e) {
            0 == e.item_count && localStorage.removeItem("show-protectors"),
            $.each(e.items, (function(e, i) {
                "yes" == getProductTag(i.handle) && (t = parseInt(t) + parseInt(i.quantity))
            }
            ));
            var i = parseInt(localStorage.getItem("screen-protectors"));
            localStorage.setItem("screen-protectors", t),
            1 == parseInt(localStorage.getItem("screen-protectors")) && 0 == i && null === localStorage.getItem("show-protectors") ? ($("#popup-discount").show(),
            localStorage.setItem("show-protectors", 1)) : (console.log(null === localStorage.getItem("show-protectors")),
            $("#popup-discount").hide())
        },
        done: function() {
            var e = parseInt(localStorage.getItem("screen-protectors"));
            localStorage.setItem("screen-protectors", t),
            1 == parseInt(localStorage.getItem("screen-protectors")) && 0 == e && null === localStorage.getItem("show-protectors") ? ($("#popup-discount").show(),
            localStorage.setItem("show-protectors", 1)) : (console.log(null === localStorage.getItem("show-protectors")),
            $("#popup-discount").hide())
        }
    })
}
customElements.define("variant-radios", VariantRadios),
$(document).ready((function() {
    setTimeout((function() {
        "" == $(".stamped-product-reviews-badge .stamped-badge-caption").html() && $(".stamped-product-reviews-badge .stamped-badge-caption").html("0 Reviews")
    }
    ), 2e3),
    $(".stamped-main-badge").click((function() {
        $("#reviewss .accordion").hasClass("active") || ($("#reviewss .accordion").addClass("active"),
        $("#reviewss .panel.content").show()),
        setTimeout((function() {
            $("html, body").animate({
                scrollTop: $("#reviewss").offset().top
            }, 1e3)
        }
        ), 500)
    }
    )),
    $("#choose_variants .swatch-element  input").click((function() {
        var t = $(this).parents(".swatch-element").find(".fbt-variant-sku").data("val")
          , e = $(this).val();
        $(this).parents(".freq-block").find(".pd-name .pd-block").text(t);
        var i = $(this).parents(".swatch").prev().prev().find('.frequently_variant_select option[value="' + e + '"]');
        $(this).parents(".swatch").prev().prev().find(".frequently_variant_select option").attr("selected", !1),
        $(i).attr("selected", !0)
    }
    )),
    "true" == localStorage.getItem("terms_and_conditions") ? ($("#agree").prop("checked", !0),
    $("span#terms_text_cart").html("I've read and agree to the"),
    $("#shopping-cart #dynamic-checkout-cart").show(),
    $("span#terms_text").html("I've read and agree to the"),
    $("#checkout").show(),
    $("#checkout_placeholder").hide(),
    $("#cart_checkout_placeholder").hide(),
    $("#cart_checkout").show()) : ($("#agree").prop("checked", !1),
    $("#shopping-cart #dynamic-checkout-cart").hide(),
    $("span#terms_text_cart").html("I agree to"),
    $("span#terms_text").html("I agree to"),
    $("#checkout").hide(),
    $("#checkout_placeholder").show(),
    $("#cart_checkout_placeholder").show(),
    $("#cart_checkout").hide()),
    $(document).on("click", "#agree", (function() {
        $("#agree").is(":checked") ? ($("span#terms_text").html("I've read and agree to the"),
        $("span#terms_text_cart").html("I've read and agree to the"),
        localStorage.setItem("terms_and_conditions", "true"),
        $("#shopping-cart #dynamic-checkout-cart").show(),
        $("#checkout").show(),
        $("#checkout_placeholder").hide(),
        $("#cart_checkout_placeholder").hide(),
        $("#cart_checkout").show()) : (localStorage.setItem("terms_and_conditions", "false"),
        $("#shopping-cart #dynamic-checkout-cart").hide(),
        $("span#terms_text_cart").html("I agree to"),
        $("span#terms_text").html("I agree to"),
        $("#checkout").hide(),
        $("#checkout_placeholder").show(),
        $("#cart_checkout_placeholder").show(),
        $("#cart_checkout").hide())
    }
    )),
    $("#checkout_placeholder").click((function() {
        $("#terms_error").addClass("show-pop")
    }
    )),
    $(".close-popup").click((function() {
        $("#terms_error").removeClass("show-pop")
    }
    ))
}
)),
addEvent(document, "mouseout", (function(t) {
    null == t.toElement && null == t.relatedTarget && (parseInt($("body .cart-count").html()) < 1 || $(".exit-popup").hasClass("displayed-once") || "yes" == localStorage.getItem("exit-popup") || ($(".exit-popup").addClass("show-exitpopup"),
    $(".exit-popup").addClass("displayed-once"),
    localStorage.setItem("exit-popup", "yes")))
}
)),
$(document).ready((function() {
    $("span.close-exitpopup").click((function() {
        $(".exit-popup").removeClass("show-exitpopup")
    }
    )),
    "yes" != localStorage.getItem("exit-popup") ? $(".exit-popup").removeClass("displayed-once") : $(".exit-popup").addClass("displayed-once")
}
)),
window.onload = function() {
    isMobile() && (window.history && history.pushState ? (null == history.state && history.pushState({
        status: "ongoing"
    }, null, null),
    window.onpopstate = function(t) {
        parseInt($("body .cart-count").html()) < 1 || $(".exit-popup").hasClass("displayed-once") || "yes" == localStorage.getItem("exit-popup") || ($(".exit-popup").addClass("show-exitpopup"),
        $(".exit-popup").addClass("displayed-once"),
        history.pushState(null, null, null),
        localStorage.setItem("exit-popup", "yes"))
    }
    ) : $(".exit-popup").removeClass("show-exitpopup"))
}
,
$(document).ready((function() {
    var t = 0;
    $.ajax({
        type: "GET",
        url: "/cart.js",
        cache: !1,
        dataType: "json",
        async: !1,
        success: function(e) {
            0 == e.item_count && localStorage.removeItem("show-protectors"),
            $.each(e.items, (function(e, i) {
                var s, o;
                s = i.handle,
                o = "",
                $.ajax({
                    type: "GET",
                    url: "/products/" + s + ".js",
                    cache: !1,
                    dataType: "json",
                    async: !1,
                    success: function(t) {
                        var e = t.tags;
                        o = e.includes("Screen Protectors") ? "yes" : "no"
                    }
                }),
                "yes" == o && (t = parseInt(t) + parseInt(i.quantity))
            }
            ));
            parseInt(localStorage.getItem("screen-protectors"));
            localStorage.setItem("screen-protectors", t),
            parseInt(localStorage.getItem("screen-protectors")) % 2 == 1 ? ($("#shopping-cart .offer_cart_notification").html('Add another protector for 20% off <span class="close-notif">X</span>'),
            $("#shopping-cart .offer_cart_notification").show()) : ($("#shopping-cart .offer_cart_notification").html(""),
            $("#shopping-cart .offer_cart_notification").hide())
        },
        done: function() {
            localStorage.setItem("screen-protectors", t),
            parseInt(localStorage.getItem("screen-protectors")) % 2 == 1 ? ($("#shopping-cart .offer_cart_notification").html('Add another protector for 20% off <span class="close-notif">X</span>'),
            $("#shopping-cart .offer_cart_notification").show()) : ($("#shopping-cart .offer_cart_notification").html(""),
            $("#shopping-cart .offer_cart_notification").hide())
        }
    }),
    $(document).on("click", ".close-notif", (function() {
        $(".offer_cart_notification").hide()
    }
    )),
    $(".close-popupoff").on("click", (function() {
        $(".popup-discount").addClass("hidepopup"),
        $("#popup-discount").hide()
    }
    ))
}
)),
$(document).ready((function() {
    if ($("body").hasClass("tdf-product-page")) {
        var t = $(".price__regular").attr("data-price");
        $(".genoapay_payment_method .installment_price").html(Shopify.formatMoney(Math.round(t / 10 * 100) / 100, "NZ${{amount}}")),
        $(".laybuy_payment_method .installment_price").html(Shopify.formatMoney(Math.round(t / 6 * 100) / 100, "NZ${{amount}}")),
        $(".afterpay_payment_method .installment_price").html(Shopify.formatMoney(Math.round(t / 4 * 100) / 100, "NZ${{amount}}")),
        $(".zip_payment_method .installment_price").html(Shopify.formatMoney(Math.round(t / 4 * 100) / 100, "NZ${{amount}}"))
    }
}
)),
$(document).ready((function() {
    function t() {
        $('[rel="lazy-stylesheet"]').length > 0 && $.each($('[rel="lazy-stylesheet"]'), (function() {
            $(this).attr("rel", "stylesheet")
        }
        ))
    }
    function e() {
        $('[rel="lazy-clickable"]').length > 0 && $.each($('[rel="lazy-clickable"]'), (function() {
            $(this).attr("rel", "stylesheet")
        }
        ))
    }
    $(window).one("scroll", (function() {
        t(),
        e()
    }
    )),
    $(window).on("load", (function() {
        let i = document.documentElement.scrollTop;
        console.log(i),
        0 != i && (t(),
        e()),
        console.log($("ul.collection-page-swatch li")),
        $(document).on("click", "ul.collection-page-swatch li", (function(t) {
            $(this).closest(".product-index").find(".collection-page-swatch li").removeClass("checkedSwatch"),
            jQuery(this).addClass("checkedSwatch");
            var e = $(this).data("variant-id")
              , i = $(this).data("variant_image")
              , s = $(this).closest(".product-index")
              , o = $(this).data("variant_price");
            s.find(".prod-image a img").attr("src", i),
            s.find(".price__container .price__regular .price-item--regular").text("NZ$" + o),
            s.find('.product-form input[name="id"]').val(e),
            s.find('.product-form input[name="id"]').attr("id", e),
            console.log(e)
        }
        ))
    }
    )),
    $(".product-size__chart a").click((function() {
        e()
    }
    ))
}
));


jQuery(document).ready(function () {
const myIntervalJ = setInterval(function () {
  const $upsellOffers = $('#tdf_upsell .tdf_bs_offer');
  $('.tdf_bs_offer_products').each(function () {
    if ($(this).html().trim() == "") {
      const heading = $(this).prev('.tdf_offer_message');
      heading.remove(); // remove the heading before the empty div
      $(this).remove(); // remove the empty div
    }
  });

  if ($upsellOffers.length) {

    $upsellOffers.each(function () {
      const $offer = $(this);
      
      // Check direct child div count
      const childDivCount = $offer.children('div').length;

      if (childDivCount > 2) {
        $offer.addClass('has-more-than-two-divs');
      } else {
         $offer.removeClass('has-more-than-two-divs');
      }

      // Check offer product count inside .tdf_bs_offer_products
      $offer.find('.tdf_bs_offer_products').each(function () {
        if ($(this).children('.tdf_bs_offer_product').length == 1) {
          $offer.addClass('has-only-one-product');
        }
      });
    });

    // clearInterval(myIntervalJ);
  }
}, 100);
});

// menu open for ipad
// $(document).ready(function () {
//     function bindDropdownToggle() {
//         if ($(window).width() >= 991 && $(window).width() <= 1200) {
//             $("li.dropdown.has_sub_menu > a").off("click.preventToggle").on("click.preventToggle", function (e) {
//                 e.preventDefault(); // Stop link redirect
                
//                 let $parentLi = $(this).parent("li.dropdown.has_sub_menu");

//                 // Remove 'active' from all sibling li
//                 $parentLi.siblings("li.dropdown.has_sub_menu").removeClass("active");

//                 // Toggle active on the clicked li
//                 $parentLi.toggleClass("active");
//             });
//         } else {
//             $("li.dropdown.has_sub_menu > a").off("click.preventToggle");
//         }
//     }

//     // Run on page load
//     bindDropdownToggle();

//     // Run on window resize
//     $(window).resize(function () {
//         bindDropdownToggle();
//     });
// });


$(document).ready(function () {
    function isiPad() {
        return /iPad/.test(navigator.userAgent) || 
               (navigator.userAgent.includes("Macintosh") && "ontouchend" in document);
    }

    function bindDropdownToggle() {
        if (isiPad()) {
            $("body").addClass("ipadview");
            $("li.dropdown.has_sub_menu > a")
                .off("click.preventToggle")
                .on("click.preventToggle", function (e) {
                    e.preventDefault(); // Stop link redirect
                    // alert("ipad")
                    
                    let $parentLi = $(this).parent("li.dropdown.has_sub_menu");

                    // Remove 'active' from all sibling li
                    $parentLi.siblings("li.dropdown.has_sub_menu").removeClass("active");

                    // Toggle active on the clicked li
                    $parentLi.toggleClass("active");
                });
        } else {
            $("li.dropdown.has_sub_menu > a").off("click.preventToggle");
        }
    }

    // Run on page load
    bindDropdownToggle();

    // Run on window resize (in case orientation changes)
    $(window).resize(function () {
        bindDropdownToggle();
    });
});
